import classNames from 'classnames';
import * as React from 'react';

export interface NavigtionButtonProps
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  icon: any;
}

export const NavigtionButton = ({ icon: Icon, disabled, ...otherProps }: NavigtionButtonProps) => (
  <button
    className={classNames({
      'px-8 py-10 focus:outline-none rounded-lg mr-8 items-center bg-primary-100 w-36 h-36': true,
      'opacity-100': !disabled,
      'opacity-40': !!disabled,
    })}
    disabled={disabled}
    {...otherProps}
  >
    <Icon
      className="text-primary-500  active:text-primary-700 hover:text-primary-700"
      wrapperClass="align-top"
    />
  </button>
);
